import { CivilUnionDetailAnscNotificationsResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionDetailAnscNotificationShared from 'shell/components/shared/ansc-notifications/research-civil-union/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegistrationCivilUnionDetailAnscNotificationPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionDetailAnscNotificationShared
        items={CivilUnionDetailAnscNotificationsResidentMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionDetailAnscNotificationPage.displayName =
  'Research Civil Union Detail Notifications CivilStatusPage component';

export default RegistrationCivilUnionDetailAnscNotificationPage;
